import React from "react";
import { Navigate, Outlet } from "react-router-dom";

const ProtectedRouteWrapper = () => {
  const isAuthenticated = localStorage.getItem("accessToken");
  return isAuthenticated ? <Outlet /> : <Navigate to="/" replace />;
};

export default ProtectedRouteWrapper;
